import "@arco-design/web-react/es/Avatar/style";
import _Avatar from "@arco-design/web-react/es/Avatar";
import _IconLoading from "@arco-design/web-react/icon/react-icon/IconLoading";
import React from 'react';
import { useSelector } from 'react-redux';
import styles from './style/index.module.less';

function Navbar() {
  const {
    userInfo,
    userLoading
  } = useSelector(state => state);
  return /*#__PURE__*/React.createElement("div", {
    className: styles.navbar
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.left
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.logo
  }, /*#__PURE__*/React.createElement("img", {
    style: {
      width: '70px'
    },
    src: "https://p1.qnvipmall.com/2022/7/21/manage/1658402524620.jpeg",
    alt: ""
  }), /*#__PURE__*/React.createElement("div", {
    className: styles['logo-name']
  }, "\u8425\u9500\u4E2D\u53F0"))), /*#__PURE__*/React.createElement("ul", {
    className: styles.right
  }, userInfo && /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(_Avatar, {
    size: 32,
    style: {
      cursor: 'pointer'
    }
  }, userLoading ? /*#__PURE__*/React.createElement(_IconLoading, null) : /*#__PURE__*/React.createElement("img", {
    alt: "avatar",
    src: "https://p1.qnvipmall.com/2022/7/21/manage/1658402795833.png"
  })))));
}

export default Navbar;